import { useState } from "react";
import { useTranslation } from "react-i18next";
import BackButtonWrapper from "../../../components/button/BackButton/wrapper";
import SearchFrErrorsReportCard from "../../../components/card/SearchFrErrorsReportCard";
import FrErrorsReportTable from "../../../components/table/FrErrorsReportTable";
import {
  FRError,
  ExportFRErrorsReportForExcelPDFBody,
} from "../../../hooks/report/interface";
import { PAGE_SIZE } from "../../../constants/common";

const FrErrorsReport = () => {
  const { t } = useTranslation();

  const [exportBody, setExportBody] =
    useState<ExportFRErrorsReportForExcelPDFBody>();
  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);
  const [search, setSearch] = useState("");

  const [allErrors, setAllErrors] = useState<FRError[]>([]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <BackButtonWrapper>
        <h1 className="text-xl md:text-2xl  dark:text-white">
          {t("frErrorsReport")}
        </h1>
      </BackButtonWrapper>

      <SearchFrErrorsReportCard
        setAllErrors={setAllErrors}
        page={page}
        search={search}
        setPages={setPages}
        setCount={setCount}
        setExportBody={setExportBody}
        pageSize={pageSize}
        setPage={setPage}
      />

      <FrErrorsReportTable
        allErrors={allErrors}
        page={page}
        pages={pages}
        setPage={setPage}
        search={search}
        setSearch={setSearch}
        count={count}
        exportBody={exportBody}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default FrErrorsReport;
